import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import useShop from "@saleor/hooks/useShop";
import { commonMessages } from "@saleor/intl";
import { stringify as stringifyQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../misc";
import {
  LanguageCodeEnum,
  PageHeaderTranslationInput
} from "../../types/globalTypes";
import TranslationsPageHeaderPage, {
  fieldNames
} from "../components/TranslationsPageHeaderPage";
import { TypedUpdatePageHeaderTranslations } from "../mutations";
import { TypedPageHeaderTranslationDetails } from "../queries";
import { UpdatePageHeaderTranslations } from "../types/UpdatePageHeaderTranslations";
import {
  // languageEntitiesUrl,
  languageEntityUrl,
  TranslatableEntities
} from "../urls";

export interface TranslationsPageHeaderQueryParams {
  activeField: string;
}
export interface TranslationsPageHeaderProps {
  id: string;
  languageCode: LanguageCodeEnum;
  params: TranslationsPageHeaderQueryParams;
}

const TranslationsPageHeader: React.FC<TranslationsPageHeaderProps> = ({
  id,
  languageCode,
  params
}) => {
  const navigate = useNavigator();
  const notify = useNotifier();
  const shop = useShop();
  const intl = useIntl();

  const onEdit = (field: string) =>
    navigate(
      "?" +
        stringifyQs({
          activeField: field
        }),
      true
    );
  const onUpdate = (data: UpdatePageHeaderTranslations) => {
    if (data.pageHeaderTranslate.errors.length === 0) {
      notify({
        status: "success",
        text: intl.formatMessage(commonMessages.savedChanges)
      });
      navigate("?", true);
    }
  };
  const onDiscard = () => {
    navigate("?", true);
  };

  return (
    <TypedPageHeaderTranslationDetails
      variables={{ id, language: languageCode }}
    >
      {pageHeaderTranslations => (
        <TypedUpdatePageHeaderTranslations onCompleted={onUpdate}>
          {(updateTranslations, updateTranslationsOpts) => {
            const handleSubmit = (field: string, data: string) => {
              const input: PageHeaderTranslationInput = {};
              if (field === fieldNames.name) {
                input.name = data;
              } else if (field === fieldNames.pcContent) {
                input.pcContent = data;
              } else if (field === fieldNames.mobileContent) {
                input.mobileContent = data;
              }
              updateTranslations({
                variables: {
                  id,
                  input,
                  language: languageCode
                }
              });
            };

            return (
              <TranslationsPageHeaderPage
                activeField={params.activeField}
                disabled={
                  pageHeaderTranslations.loading ||
                  updateTranslationsOpts.loading
                }
                languageCode={languageCode}
                languages={maybe(() => shop.languages, [])}
                saveButtonState={updateTranslationsOpts.status}
                onBack={() => history.go(-1)}
                onEdit={onEdit}
                onDiscard={onDiscard}
                onLanguageChange={lang =>
                  navigate(
                    languageEntityUrl(lang, TranslatableEntities.pageHeader, id)
                  )
                }
                onSubmit={handleSubmit}
                pageHeader={maybe(() => pageHeaderTranslations.data.pageHeader)}
              />
            );
          }}
        </TypedUpdatePageHeaderTranslations>
      )}
    </TypedPageHeaderTranslationDetails>
  );
};
TranslationsPageHeader.displayName = "TranslationsPageHeader";
export default TranslationsPageHeader;
